module.exports = __webpack_public_path__ + "static/segmentation-location-3-9a6505aa3f887776d2ae93325f647d6e.png";